import React from "react";

const Contact = () => {
  return (
    <div className="w-full flex flex-col gap-10 bg-primario p-10 rounded-30 ">
      <div>
        <p className="text-xl text-white hyphens-none">
          Si tienes alguna pregunta específica o necesitas información adicional
          sobre nuestros cursos, servicios corporativos o cualquier otro tema
          relacionado con Brighton Centro de Inglés, no dudes en contactarnos.
          Estamos aquí para ayudarte.
        </p>
      </div>
      <form
        action="https://formsubmit.co/contactos@brightonenglishcenter.edu.co"
        method="POST"
        className="flex flex-col gap-5"
      >
        <input type="hidden" name="_captcha" value="false" />
        <input type="hidden" name="_subject" value="Nuevo mensaje" />
        <div className="flex flex-row gap-5">
            <input
            className="w-1/2 p-2 rounded-lg border-2 border-transparent focus:outline-none focus:ring-1 focus:ring-sky-500 focus:border-sky-500"
            type="text"
            name="name"
            id=""
            placeholder="Nombres y apellidos"
            required
            />
            <input
            className="w-1/2 p-2 rounded-lg border-2 border-transparent focus:outline-none focus:ring-1 focus:ring-sky-500 focus:border-sky-500"
            type="email"
            name="email"
            id=""
            placeholder="Correo"
            required
            />
        </div>
        <label className="text-white" htmlFor="message">Tu mensaje</label>
        <textarea
          className="p-2 rounded-lg border-2 border-transparent focus:outline-none focus:ring-1 focus:ring-sky-500 focus:border-sky-500 "
          type="text"
          name="message"
          id="message"
          rows={4}
          placeholder="Escribe tu mensaje aquí..."
          required
        />
        <input
          type="hidden"
          name="_next"
          value="http://localhost:3000/gracias"
        ></input>
        <button
          className="hover:bg-terciario self-end px-5 py-2 rounded-lg rounded-tl-none text-primario font-bold bg-white text-xl"
          type="submit"
          target="_blank"
        >
          Enviar
        </button>
      </form>
    </div>
  );
};

export default Contact;
